import styled from "styled-components";

interface MainContainerProps {
  active?: boolean;
  isSubSidebarOpen?: boolean;
  theme: string;
  isPlayerSearchActive?: boolean;
  isBlurred?: boolean;
  activeTab?:string
}

const MainContainerWidth = {
  active: "calc(100% - 200px)",
  inactive: "calc(100% - 60px)",
};

const MainContainerLeft = {
  active: "216px",
  inactive: "60px",
};

export const MainContainer = styled.div<MainContainerProps>`
  height: 100%;
  left: ${(props) => (props.active ? MainContainerLeft.inactive : MainContainerLeft.inactive)};
  width: ${(props) => (props.active ? MainContainerWidth.inactive : MainContainerWidth.inactive)};
  overflow-y: auto;
  overflow-x: auto;
  transition: width 200ms ease; /* Transition time set to 200ms //21-Mar-2024  transition: 1s;*/
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
  position: fixed;
  z-index: ${(props) => (props.activeTab === "Possessions" ? "999 !important": "-1")};
  &::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: brightness(0.5);
    background-color: ${({ theme }) => theme.backgroundOpacity};
    opacity: ${(props) => (props.active ? "1" : "0")};
    z-index: -1;
    -webkit-backdrop-filter: ${(props) => (props.isBlurred ? "" : "blur(8px)")};
    backdrop-filter: ${(props) => (props.isBlurred ? "" : "blur(8px)")};
    transition: all 300ms ease;
  }
  &.blur-player-search:after {
    // background: ${({ theme }) => theme.blurBackground};
  }
`;
